import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { addResizeListener, removeResizeListener } from "element-ui/src/utils/resize-event";

/**
 * How to use
 * <el-table height="100px" v-el-height-adaptive-table="{bottomOffset: 30}">...</el-table>
 * el-table height is must be set
 * bottomOffset: 30(default)   // The height of the table from the bottom of the page.
 */

var doResize = function doResize(el, binding, vnode) {
  var $table = vnode.componentInstance;
  var value = binding.value;
  if (!$table.height) {
    throw new Error("el-$table must set the height. Such as height='100px'");
  }
  var bottomOffset = value && value.bottomOffset || 30;
  if (!$table) return;
  var height = window.innerHeight - el.getBoundingClientRect().top - bottomOffset;
  $table.layout.setHeight(height);
  $table.doLayout();
};
export default {
  bind: function bind(el, binding, vnode) {
    el.resizeListener = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return doResize(el, binding, vnode);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    // parameter 1 is must be "Element" type
    addResizeListener(window.document.body, el.resizeListener);
  },
  inserted: function () {
    var _inserted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(el, binding, vnode) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return doResize(el, binding, vnode);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function inserted(_x, _x2, _x3) {
      return _inserted.apply(this, arguments);
    }
    return inserted;
  }(),
  unbind: function unbind(el) {
    removeResizeListener(window.document.body, el.resizeListener);
  }
};